import { P500UIButtonsModule, P500UIIconsModule, P500UIProgressModule, P500UITooltipModule } from '@platform500services/p500-ui-kit';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MetricInfoModal } from './metric-info.modal';
import { BaseMetricCardModule } from '../../components/base-metric-card/base-metric-card.module';
import { NetworkMetricCardModule } from '../../components/network-metric-card/network-metric-card.module';

@NgModule({
  imports: [
    CommonModule,
    P500UIIconsModule,
    P500UIButtonsModule,
    P500UITooltipModule,
    BaseMetricCardModule,
    NetworkMetricCardModule,
    P500UIProgressModule,
  ],
  declarations: [MetricInfoModal],
  exports: [MetricInfoModal],
})
export class MetricInfoModalModule {}
